import React from 'react'
import Icon from '../../atoms/Icon/Icon'
import LoadingSvg from '../Loading/Loading'
import Link from 'next/link'

const Button = ({
  label,
  variant,
  colorVariant,
  size,
  responsive,
  icon,
  bg,
  color,
  icon_name,
  icon_size,
  icon_pos,
  onClick,
  disabled,
  className,
  type,
  href,
  target,
  loading,
  noPointer,
  ariaLabel,
  next = false,
}) => {
  const ButtonIcon = () => (icon ? icon : <Icon icon_name={icon_name} size={icon_size} />)

  const classNames = `button button__${variant ? variant : 'ghost'} button__${size ? size : 'medium'}` +
    (responsive ? ' button__' + size + '--responsive' : '') +
    (colorVariant ? ' button--' + colorVariant : '') +
    (noPointer ? ' button__no-pointer' : '') +
    (className ? ' ' + className : '')
  
  const getContent = () => (
    <>
      {((loading && !href) || icon || icon_name) && (
        <div className={`button__icon button__icon--${icon_pos === 'left' ? 'left' : 'right'}`}>
          {loading ? (
          <div style={{ alignSelf: 'center' }}>
            <LoadingSvg width={24} color={variant === 'primary' || !variant ? 'white' : null} />
          </div>
          ) : (
            <ButtonIcon style={{ alignSelf: 'center' }} />
          )}
        </div>
      )}
      <span className="button__label">{label}</span>
    </>
  )

  const getStyle = () => ({
    order: 0,
    ...(bg ? { backgroundColor: bg } : {}),
    ...(color ? { color } : {}),
  })

  return href ? (
    next ? (
      <Link
        href={href}
        target={target}
        className={classNames}
        style={getStyle()}
        aria-label={ariaLabel}
      >
        {getContent()}
      </Link>
    ) : (
      <a
        href={href}
        target={target}
        className={classNames}
        style={getStyle()}
        aria-label={ariaLabel}
      >
        {getContent()}
      </a>
    )
  ) : (
    <button
      type={type}
      disabled={disabled}
      onClick={(e) => {
        if (!loading && !!onClick) onClick(e)
      }}
      className={classNames}
      style={getStyle()}
      aria-label={ariaLabel}
    >
      <div className="button__content">
        {getContent()}
      </div>
    </button>
  )
}

export default React.memo(Button)
